import classNames from "classnames";
import style from './get_udid.module.css'
import { useState } from "react";

const ModalUDID = ({
    t, id, name, reg_date, udid, setShowModal, showModal, showNotification
}) => {


    function closeModal() {
            setShowModal(false)
      
        }
 
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closeModal();
        }
    });
    function downloadCertificate() {
        try {
            const fileUrl = `https://api2.ipalinks.ru/v2/download-certificate/${id}/${udid}.zip`
            
            if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initDataUnsafe && window.Telegram.WebApp.initDataUnsafe.user){
                    window.Telegram.WebApp.downloadFile({
                        url: fileUrl,
                        file_name: `${name}(${udid}).zip`
                    }, (item) => {
                        console.log(item)
                    })
                    showNotification(`Скачивание ${name} начато!`, 'success');
                    closeModal();
                } else {
                    window.open(fileUrl, '_self')
                    showNotification(`Скачивание ${name} начато!`, 'success');
                    closeModal();
                }
            } catch(error) {
                console.log(error)
                showNotification(`Ошибка ${error}`, 'error');

            }
        }

    return (
        <div id="ready-device" className={classNames(style.modal, showModal ? style.show: '')}>
        <div className="modal-content">
            <div className="modal-color">
                <button className="close-btn" onClick={closeModal}>&times;</button>
                <div className="modal-header">
                    <h2>{t('download_cert')}</h2>
                    <p>{t('cert_ready')}</p>
                </div>
                
                <div className="modal-device-info">
                    <h3>{t('device_info')}</h3>
                    <div className="modal-info-row">
                        <span className="modal-info-label">{t('name')}:</span>
                        <span className="modal-info-value">{name}</span>
                    </div>
                    <div className="modal-info-row">
                        <span className="modal-info-label">UDID:</span>
                        <span className="modal-info-value">{udid}</span>
                    </div>
                    <div className="modal-info-row">
                        <span className="modal-info-label">{t('status')}:</span>
                        <span className="modal-info-value">✅ {t('ready')}</span>
                    </div>
                </div>
                
                <div className="download-section">
                    <button className="download-btn" onClick={downloadCertificate}>
                        <span>📦</span>
                        <span>{t('download_cert_btn')} (.zip)</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    )
}

export default ModalUDID;